interface IconCloseProps {
  size?: string
  color?: string
}

export default function IconClose({
  size = '34px',
  color = '#2D4040',
}: IconCloseProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="4.24264"
        y1="3"
        x2="31"
        y2="29.7574"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
      />
      <line
        x1="3"
        y1="-3"
        x2="40.8406"
        y2="-3"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 34 3)"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  )
}
